var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orchardcore-content"},[(_vm.show)?_c('vue-markdown',{attrs:{"source":_vm.text,"data-orchardcore-contentitem":_vm.item.alias,"postrender":_vm.markdownPostRender,"linkify":false}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }